module.exports = __webpack_public_path__ + "img/shepa2.76ba24ac.jpg";